export const messageRequired = "Bitte füllen Sie das Feld aus";
export const messageEmail = "Keine gültige E-Mail";
